module.exports = __webpack_public_path__ + "static/media/upper.9e27d2d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/upper.svg
// module id = 1066
// module chunks = 0